<section class="termos">
  <img src="assets/images/verify-safe-3.png" width="200" alt="seguranca" />

  <div class="termos__title">Privacidade e Segurança</div>

  <p>
    Marque as opções abaixo para <strong>concordar</strong> com os termos e
    condições da Omni e confirmar ser este o seu celular/e-mail pessoal, podendo
    ser, por este meio, contatado para qualquer fim.
  </p>

  <div class="termos-checkbox">
    <div class="content">
      <input class="form-check-input" type="checkbox" (change)="emitChange('termos-de-uso')" [(ngModel)]="termosDeUso"/>
      <span>
        Li e concordo com os
        <a (click)="onClickTermos('termos-de-uso')">
          termos de uso e política de privacidade
        </a>
      </span>
    </div>
    <div class="content">
      <input class="form-check-input" type="checkbox" (change)="emitChange('scr')" [(ngModel)]="scr"/>
      <span>
        Autorizo a consulta das minhas
        <a (click)="onClickTermos('scr')"> informações de crédito (SCR) </a>
      </span>
    </div>
  </div>
</section>
